import axios            from 'axios';
import authHeader       from 'services/auth-header';

class MentalHealthService  {
  getMoodInsights(params){
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `doctors/moods`, {
      headers: authHeader(),
      params: params,
    })
    .then((response) => {
      return response.data;
    });
  }
  getAssessments(params){
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `doctors/stress_assessments`, {
      headers: authHeader(),
      params: params,
    })
    .then((response) => {
      return response.data;
    });
  }
}

export default new MentalHealthService();